const lightTheme = {
  background: '#ffffff',
  text: {
    base: '#56B9C3',
    black: '#3B3B3B',
    darkGrey: '#878787',
    green: '#5BBD94',
    graphicGreen: '#66A38C',
    white: '#ffffff',
    danger: '#ff4d4f',
    success: '#52C41A',
    disabled: '#DDDDDD',
  },
  white: '#ffffff',
  whiteGrey: '#F1F1F1',
  grey: '#DDDDDD',
  primary: '#56B9C3',
  vermilion: '#E75925',
}

const darkTheme = {
  background: '#000000',
  text: {},
  primary: '#56B9C3',
}

export const themes = { light: lightTheme, dark: darkTheme }
